var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps"},[_c('transition',{staticClass:"fade",attrs:{"name":"fade","mode":"out-in"}},[(_vm.step === 1)?_c('step-one',{attrs:{"countriesOptions":_vm.countriesOptions}}):_vm._e(),(_vm.step === 2)?_c('step-two',{attrs:{"country":_vm.country,"survey":_vm.survey,"getSurvey":_vm.getSurvey}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }